// extracted by mini-css-extract-plugin
export default {"checkbox":"Fields_checkbox__EdpyA"};